export default __webpack_public_path__ + "static/media/icon-desligar.48dbcaaa.svg";